export default __webpack_public_path__ + "static/media/V4.ff6544ab.svg";